import script from "./supplement-sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-sidebar.vue?vue&type=script&setup=true&lang=js"

import "./supplement-sidebar.vue?vue&type=style&index=0&id=448e2817&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448e2817"]])

export default __exports__